import React from 'react';
import AccordionComponent from '../../../../components/common/Accordion';
import BadgesComponent from '@components/common/Badges';
import './HRPHistory.css';
import Button from '@components/common/Button';
import BackArrowsvg from '../../../../assets/svg_main/BackArrowIconSvg.svg';
import FormatDate from '@utils/dateFormat';
import Spinner from '@components/common/Spinner';
import { COMMON_FIELD_NAME, COMMON_UNITS } from '@constants/index';

const services = ['ogtt_test', 'hbsag_test', 'tb_screening_test', 'thyroid_test', 'syphilis_test', 'rapid_malaria_test']
const HRPHistory = ({
  hrpData,
  handleRowClick,
  isLoading,
  setSelectedHrpData,
}: any) => {
  const handleBackArrow = () => {
    setSelectedHrpData(null);
  };

  const showServiceDate = (service: any) => services?.includes(service);

  return (
    <>
      <div className="hrp_history_section">
        <div className="hrp_history_top">
          <div className="show_title_details">
            <Button
              onClick={() => {
                handleBackArrow();
              }}
              disabled={false}
              id=""
              buttonName={''}
              colorType={'backArrowButton'}
              icon={<BackArrowsvg />}
              iconPosition={'left'}
            />
            <BadgesComponent
              className="over-badge"
              badgeName={`History of ${hrpData?.hrp_name}`}
              variant="primary-1"
              badgeType="case5"
            />
          </div>
        </div>

        <div className="accordion_component">
          {isLoading ? (
            <div style={{ textAlign: 'center' }}>
              <span>Loading...</span>
              <Spinner />
            </div>
          ) : (
            <>
              {hrpData?.data?.map((el: any, index: any) => (
                <>
                  <AccordionComponent
                    key={`${el?.service_date}${index}`}
                    header={
                      <div className="accordion_heading">
                        <span>{FormatDate(el?.visit_date)}</span>
                        {el?.services.length > 0 && <BadgesComponent
                          className="over-badge"
                          badgeName={el?.services[0]?.treatment_status_name}
                          badgeType="case7"
                          variant={el?.services[0]?.treatment_status_name !== "Treated" ? "info" : "success"}
                        />}
                      </div>
                    }
                  >
                    {el?.services?.map((item: any, index: any) => (
                      <>
                      <div key={`${item?.service_name}${index}`}>
                        <div>{item?.service_name === COMMON_FIELD_NAME.HB_GM ? COMMON_FIELD_NAME.HB_DL : null} </div>
                        <div>
                          {item?.service_report}{' '}
                          <span style={{ marginLeft: '10px' }}>
                            {item?.service_name === COMMON_FIELD_NAME.HB_GM ? COMMON_UNITS.G_DL : null}
                          </span>
                        </div>
                      </div>
                      {showServiceDate(item?.service_code) && 
                        <div key={`dot${index}`}>
                        <div>Date of Test</div>
                        <div>
                          {FormatDate(item?.service_date)}                          
                        </div>
                      </div>
                      }
                      </>
                    ))}
                  </AccordionComponent>
                </>
              ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default HRPHistory;
